(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-custom"]) return;
  try {
    
document.querySelectorAll('.hlx-hero').forEach(function (hero) {
  var slides = hero.querySelectorAll('[data-hlx-slide]');
  var dots = hero.querySelectorAll('[data-hlx-dot]');
  if (slides.length < 2) return;
  // Seamless crossfade (2026-10-08): videos keep moving (loop) so nothing freezes. When a slide
  // comes in, its video restarts from the top, and the slide leaves just before the video ends,
  // so a short clip (the 13 candle) plays exactly once instead of looping inside the slide.
  // The next video is rewound and started PRIME_MS before the crossfade (while still hidden),
  // so it is already moving when it fades in - no buffering hitch at the transition.
  var SLIDE_MS = 9000, FADE_MS = 800, EARLY_MS = 250, PRIME_MS = 500;
  var current = 0, timer = null, primeTimer = null;
  function videoOf(i) { return slides[i].querySelector('video'); }
  function nextIndex() { return (current + 1) % slides.length; }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function prime(i) {
    var v = videoOf(i);
    if (!v) return;
    try { v.currentTime = 0; } catch (e) {}
    play(v);
  }
  function schedule(ms) {
    clearTimeout(timer); clearTimeout(primeTimer);
    var n = nextIndex();
    primeTimer = setTimeout(function () { prime(n); }, Math.max(0, ms - PRIME_MS));
    timer = setTimeout(function () { show(n); }, ms);
  }
  function slideTime(v) {
    if (!v || !isFinite(v.duration) || !v.duration) return SLIDE_MS;
    // the clip started PRIME_MS early, so leave just before it reaches its end
    return Math.min(SLIDE_MS, v.duration * 1000 - EARLY_MS - PRIME_MS);
  }
  // Clean cuts only (2026-10-17): every slide plays its video ONCE, and the moment it ends the hero
  // cuts straight to the next slide with no blend. The next video is parked on its first frame
  // beforehand, so nothing restarts or ghosts during the change.
  function cutTo(n) {
    clearTimeout(timer); clearTimeout(primeTimer);
    hero.classList.add('hlx-hero--nofade');
    show(n);
    setTimeout(function () { hero.classList.remove('hlx-hero--nofade'); }, 120);
  }
  function startSlide(i) {
    var v = videoOf(i), n = nextIndex();
    var nv = videoOf(n);
    if (nv && n !== i) { try { nv.pause(); nv.currentTime = 0; } catch (e) {} }
    if (!v) { clearTimeout(timer); timer = setTimeout(function () { if (current === i) cutTo(nextIndex()); }, SLIDE_MS); return; }
    v.loop = false;
    if (v.ended || (v.paused && v.currentTime > 0.1)) { try { v.currentTime = 0; } catch (e) {} }
    if (v.paused) play(v);
    var done = false;
    function end() { if (done || current !== i) return; done = true; cutTo(nextIndex()); }
    v.addEventListener('ended', end, { once: true });
    // safety net if 'ended' never fires (throttled tab): cut shortly after the clip should have finished
    function arm() { clearTimeout(timer); timer = setTimeout(end, Math.max(500, (v.duration - v.currentTime) * 1000 + 400)); }
    if (v.readyState >= 1 && isFinite(v.duration)) arm(); else v.addEventListener('loadedmetadata', arm, { once: true });
  }
  function show(i) {
    var prev = videoOf(current);
    if (prev) setTimeout(function (pv, pi) { return function () { if (current !== pi) pv.pause(); }; }(prev, current), FADE_MS + 50);
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    current = (i + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
    startSlide(current);
  }
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { show(i); });
  });
  startSlide(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-bundles"]) return;
  try {
    
document.querySelectorAll('.hlx-tile--hoverable').forEach(function (tile) {
  var video = tile.querySelector('.hlx-tile__hover-video');
  if (!video) return;
  var loaded = false;
  function load() {
    if (loaded) return;
    loaded = true;
    video.src = video.dataset.src;
  }
  tile.addEventListener('mouseenter', function () {
    load();
    video.currentTime = 0;
    video.play().catch(function () {});
  });
  tile.addEventListener('mouseleave', function () {
    video.pause();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-collection"]) return;
  try {
    
document.querySelectorAll('.hlx-tile--hoverable').forEach(function (tile) {
  var video = tile.querySelector('.hlx-tile__hover-video');
  if (!video) return;
  var loaded = false;
  function load() {
    if (loaded) return;
    loaded = true;
    video.src = video.dataset.src;
  }
  tile.addEventListener('mouseenter', function () {
    load();
    video.currentTime = 0;
    video.play().catch(function () {});
  });
  tile.addEventListener('mouseleave', function () {
    video.pause();
  });
});

  } catch(e) { console.error(e); }
})();
})();
